// Action Types
const SET_REGISTRATION_DATA = 'SET_REGISTRATION_DATA';
export const REGISTRATION_UPDATE_WHY_HERE = 'UPDATE_WHY_HERE';
// Action Creators
export const setRegistrationData = (data) => ({
    type: SET_REGISTRATION_DATA,
    payload: data,
});


//Action creator to update only the 'WhyHere' field in userData
export const registrationUpdateWhyHere = (newWhyHereValue) => {
    return {
      type: REGISTRATION_UPDATE_WHY_HERE,
      payload: newWhyHereValue,
    };
  };
  
// Initial State
const initialState = {
    registrationData: {},  // Initial empty object for storing the response data
};

// Reducer Function
const registrationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_REGISTRATION_DATA:
            return {
                ...state,
                registrationData: action.payload,  // Store the complete response data
            };
            case REGISTRATION_UPDATE_WHY_HERE:
                return {
                  ...state,
                  userData: {
                    ...state.registrationData, // Keep other fields intact
                    WhyHere: action.payload, // Only update 'WhyHere' field
                  },
                };
        default:
            return state;
    }
};

export default registrationReducer;